import { render, staticRenderFns } from "./GenerateResult.vue?vue&type=template&id=0afad374"
import script from "./GenerateResult.vue?vue&type=script&lang=ts"
export * from "./GenerateResult.vue?vue&type=script&lang=ts"
import style0 from "./GenerateResult.vue?vue&type=style&index=0&id=0afad374&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports